import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  padding: ${size[24]};
  display: flex;
  flex-direction: column;
  gap: ${size[32]};
  background-color: ${theme.palette.background.main};
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    gap: ${size[48]};
  }
`

export const contactItems = css`
  display: flex;
  flex-direction: column;
  gap: ${size[24]};

  ${breakpoint.up('smMd')} {
    max-width: ${width.container.wide};
    width: 100%;
    margin: 0 auto;
    flex-direction: row;
    gap: ${size[48]};
  }
`

export const contactItem = css`
  display: flex;
  gap: ${size[16]};

  ${breakpoint.up('smMd')} {
    flex-direction: column;
    flex-basis: 300px;
  }
`

export const icon = (theme: Theme) => css`
  width: ${size[48]};
  height: ${size[48]};
  border-radius: 50%;
  background-color: ${theme.palette.primary.lowContrast};

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${theme.palette.primary.mainContrast};
  }

  ${breakpoint.up('smMd')} {
    width: ${size[56]};
    height: ${size[56]};

    svg {
      width: ${size[32]};
      height: ${size[32]};
    }
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.palette.text.title};
  font-size: ${pxToRem(32)};
  font-weight: 500;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(28)};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const subtitle = css`
  font-size: ${pxToRem(20)};
  font-weight: 600;
  margin-top: ${size[8]};
`

export const description = css`
  font-size: ${pxToRem(20)};
  margin-top: ${size[8]};
`

export const name = css`
  font-size: ${pxToRem(20)};
  font-weight: 600;
  margin-top: ${size[8]};
`

export const link = css`
  margin-top: ${size[24]};

  a span {
    font-weight: 600;
  }
`

export const image = css`
  margin-top: ${size[16]};
`

export const address = css`
  max-width: ${width.container.wide};
  width: 100%;
  margin: ${size[32]} auto 0;
  display: flex;
  flex-direction: column;
  gap: ${size[12]};
`

export const addressTitle = css`
  font-size: ${pxToRem(32)};
  font-weight: 500;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(28)};
  }
`

export const columns = css`
  display: flex;
  flex-direction: column;
  gap: ${size[24]};

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    gap: ${size[48]};
  }
`

export const column = (theme: Theme) => css`
  p {
    color: ${theme.palette.text.title};
    margin: 0;
    font-size: ${pxToRem(20)};
    line-height: 1.5;
  }

  strong {
    font-weight: 700;
  }

  ${breakpoint.up('smMd')} {
    flex-basis: 300px;
  }
`
